// extracted by mini-css-extract-plugin
export default {"mainDetailsContainer":"RecipeMainDetails_mainDetailsContainer__+puFL","info":"RecipeMainDetails_info__cFgB4"};